import { cartApproverMessageStyles } from "@insite/content-library/Widgets/Common/CartApproverMessage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartApproverMessageStyles.approvingWrapper = {
    css: css`
        text-align: center;
        padding: 10px;
        background-color: ${getColor("common.backgroundContrast")}; ;
    `,
};
